module.exports = __webpack_public_path__ + "static/img/column_recommendation2_1.e5b7fe2f.png";